import React, {Fragment} from 'react';
import { findDOMNode } from 'react-dom';
import { ShareIcon } from '@bizzabo/icons';
import classname from 'classnames';
import { Overlay} from 'react-bootstrap';

import {useOpenDialogState} from './useOpenDialogState';
import ShareAgendaPopOver from './ShareAgendaPopOver';

const returnUrl = (websiteType, agendaUrl, entityId, entityToShare) => {
    const entityText = entityToShare === 'Session' ? 'session' : 'speakers';
    const bizzaboShareUrl = `${agendaUrl}/${entityText}/${entityId}`;
    const independentShareUrl = `${agendaUrl}?agendaPath=${entityText}/${entityId}`;

    const shareUrl = websiteType === 'independent' ? independentShareUrl : bizzaboShareUrl ;
    return shareUrl;
};

function AgendaShareButton({event, eventUrls, entityId, color, entityToShare}) {
    const [isPopOverOpen, togglePopOverAction, onTipHide] = useOpenDialogState();
    const ShareRef = React.createRef();

    const {websiteType} = event || {};
    const {agendaUrl} = eventUrls || {};
    const urlToShare = returnUrl(websiteType, agendaUrl, entityId, entityToShare);

    return (
        <Fragment>
            {entityToShare === 'Session' ?
                <div
                    ref={ShareRef}
                    onClick={togglePopOverAction}
                    className={classname('session-button', {'session-button--toggle': isPopOverOpen})}>
                    <ShareIcon fill={`var(--page-main-color, ${color})`} className="share"/>
                    <span>Share</span>
                </div> :
                <button
                    ref={ShareRef}
                    onClick={togglePopOverAction}
                    className="speaker-share-button bz-flex-row font-size-12 custom-color color-5-background">
                    <ShareIcon className="margin-right-xs" width="20px" height="20px" fill={`var(--page-contrast-to-main-color, ${color})`}/>
                    Share
                </button>
            }
            <Overlay
                target={() => findDOMNode(ShareRef.current)}
                placement="bottom"
                rootClose={true}
                onHide={onTipHide}
                show={isPopOverOpen}>
                <ShareAgendaPopOver
                    className="agenda-button-popover--wide agenda-button-popover--long"
                    urlToShare={urlToShare}
                    entity={entityToShare}
                />
            </Overlay>
        </Fragment>
    );

}
export default AgendaShareButton;

